import React from "react";
import { ProcedureTagBaseInfo } from "../../../../application/domain/proc-management";
import { ListInput } from "./list-input";
import { TagInputForProc } from "./tag-input-for-proc";
import type { InputProps, PathProps } from "./types";

const notices = [
  "手続きの検索時に絞り込みを行うタグを指定することができます。",
];

type Props = InputProps &
  PathProps & {
    value: ProcedureTagBaseInfo[];
    organizationId: string;
    validationErrors: string[];
  };

export const ProcedureTagsListInput: React.FC<Props> = ({
  value,
  organizationId,
  onChange,
  disabled = false,
  basePath,
  shouldDisplayError,
  validationErrors,
}) => {
  return (
    <ListInput
      label="タグ"
      boldLabel
      mb={2}
      component={TagInputForProc}
      componentProps={value.map((tag, i) => ({
        ...tag,
        name: tag.name,
        priority: tag.name,
        orgId: organizationId,
        onChange,
        selectedTags: value,
        shouldDisplayError,
        errorMsg: validationErrors[i],
      }))}
      basePath={basePath}
      onPush={() => {
        onChange(basePath, [...value, {}]);
      }}
      onRemove={(i) => {
        onChange(basePath, [...value.slice(0, i), ...value.slice(i + 1)]);
      }}
      disabled={disabled}
      notices={notices}
      maxLength={10}
    />
  );
};
